import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { setAnswer } from "../../../actions/answer";
// import { animateScroll } from "react-scroll";
import "./styles.css";

class QuestionnaireRating extends Component {

  render() {
    const { data, answer, setAnswer } = this.props;
    const rateThumbs =
      Array.from({ length: data.scaleTo }, () => data.scaleFrom)
    .map((item, index) => item + index);
    return (
      <div className="content">

        {/* <h4>Въпрос {data.questionNumber}</h4>*/}

        <div class="title">{data.text}</div>
        <div className="learn"><p>{data.details}</p></div>

        <div className="form rating">
          <div className="rating-steps">
            <div className="rating-numbs">
              {rateThumbs.map(thumb => (
                <div
                  key={thumb}
                  className={`rate-numb ${answer === thumb ? "selected" : ""}`}
                  onClick={() => setAnswer({ answer: thumb })}
                >
                  <div>{thumb}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="line-wrap">
            <div className="rating-line" />
            <div className="rating-line-active" style={{width:answer / data.scaleTo * 100 + "%"}} />
          </div>

        </div>
      </div>
    );
  }
}

const mstp = (state, ownProps) => ({
  answer: state.answer.collection[ownProps.match.params.id - 1]
});

const mdtp = (dispatch, ownProps) => ({
  setAnswer: payload =>
    dispatch(
      setAnswer({
        id: +ownProps.match.params.id,
        ...payload
      })
    )
});

export default withRouter(
  connect(
    mstp,
    mdtp
  )(QuestionnaireRating)
);



// WEBPACK FOOTER //
// ./src/screens/Questionnaire/QuestionnaireRating/QuestionnaireRating.js